<template>
  <span v-html="iconSvg" :style="{ width: size }"></span>
</template>
<script>
import feather from "feather-icons";
export default {
  name: "baseIcon",
  props: {
    icon_name: String,
    size: {
      type: Number,
      default: 20,
    },
  },
  computed: {
    iconSvg() {
      let attrs = {};
      attrs.width = this.size;
      attrs.height = this.size;
      return feather.icons[this.icon_name].toSvg(attrs);
    },
  },
};
</script>